import { render } from "./Vue.vue?vue&type=template&id=320c28e5&scoped=true&ts=true"
import script from "./Vue.vue?vue&type=script&lang=ts"
export * from "./Vue.vue?vue&type=script&lang=ts"

import "./Vue.vue?vue&type=style&index=0&id=320c28e5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Border-Card-UI/Border-Card-UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320c28e5"]])

export default __exports__